<template>
  <div id="inicio" class="wrapper" style="margin-top: 0px;">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100">
            <h1 class="title">Nunca foi tão fácil se retratar</h1>
            <h4>
              Pedir <b>perdão</b> ou se <b>desculpar</b> nem sempre é fácil.
              Sabendo disso, resolvemos criar este serviço pre te dar uma mãozinha.
            </h4>
            <br />
            <md-button href="#/retratar" class="md-success md-lg" target="_blank">
              <i class="fas fa-play"></i>
              retrate-se
            </md-button>
            <br/>
            <br/>
          </div>

          <div class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100">
            <carousel :per-page="1" loop :speed="700" autoplay :autoplay-timeout="5000" :mouse-drag="false"
              navigationEnabled navigationNextLabel="<i class='material-icons'>keyboard_arrow_right</i>"
              navigationPrevLabel="<i class='material-icons'>keyboard_arrow_left</i>">

              <slide v-for="item in slides" :key="item.id">
                <a :href="item.url" target="_blank">
                  <div class="carousel-caption">
                    <h4>
                      {{ item.title }}
                    </h4>
                  </div>
                  <img :src="item.img" :alt="item.title" style="height: 100%; object-fit: cover;" />
                </a>
              </slide>

            </carousel>
          </div>
        </div>
      </div>
    </parallax>

    <div class="main main-raised">
      <div id="comofunciona" class="section text-center">
        <div class="container">
          <h2 class="title">Como Funciona</h2>

          <div class="team">

            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <h4 class="description text-center">
                  Retratar-se exige um mínimo de <b>arrependimento</b> ou vontade de <b>corrigir</b>
                  ou tentar <b>acertar</b> o que foi feito.
                  <br /><br />
                  Se ainda não tem certeza que é isso que deseja fazer, deixamos alguns links destacados
                  no início da página para você ler e tentar se convencer disso! <b>=)</b>
                </h4>
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <img
                  src="https://us.123rf.com/450wm/ankomando/ankomando1605/ankomando160500296/57623319-office-workers-apologize.jpg?ver=6"
                  class="como-funciona" />
              </div>
            </div>

            <br />
            <br />

            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100">
                <img
                  src="https://images.all-free-download.com/images/graphiclarge/certificate_template_colorful_flat_geometrical_elements_decor_6854624.jpg"
                  class="como-funciona" />
              </div>
              <div class="md-layout-item md-size-50 md-small-size-100">
                <h4 class="description text-center">
                  Ao clicar em <b>Retratar-se</b>, iremos conduzí-lo a um formulário
                  para te ajudar a confeccionar um <b>lindo</b>, <b>tocante</b> (e <b>bem humurado?</b>)
                  pedido de retratação!
                  <br /><br />
                  Fazemos isso de forma rápida, leve e pouco dolorosa.
                </h4>
              </div>
            </div>
          </div>

          <br />
          <br />

          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <h4 class="description text-center">
                Por fim, será gerado um <b>pedido formal de retratação</b> que pode
                ser enviado para a pessoa ofendida.
                <br /><br />
                Vamos gerar um número único e exclusivo para o seu pedido que
                ficará armazenado aqui até o prazo de validade que você definiu
                quando estava preenchendo o formulário.
              </h4>
            </div>
            <div class="md-layout-item md-size-50 md-small-size-100">
              <img src="https://mb.cision.com/Public/18747/3031698/892befd36dec4c8e_800x800ar.jpg"
                class="como-funciona" />
            </div>
          </div>

          <br />
          <br />

          <h3 class="title text-center">Ainda tem dúvida?</h3>
          <div class="md-layout">
            <iframe id="ytplayer" src="https://www.youtube.com/embed/LX_YP3qKakM" frameborder="0" allowfullscreen=""
              style="width:90%;border-radius:10px;margin: 0 auto;max-width:700px;height:51.2vw;max-height:398px">
            </iframe>
          </div>

          <br />
          <br />

          <div class="md-layout">
            <md-button href="#/retratar" class="md-success md-lg" target="_blank"
              style="width: auto; margin: 0 auto;">
              <i class="fas fa-play"></i>
              retrate-se agora
            </md-button>
          </div>
        </div>
      </div>








      <div id="depoimentos" class="section text-center">
        <div class="container">
          <h2 class="title">Depoimentos</h2>
          <div class="team">
            <div class="md-layout">

              <swiper :slidesPerView="3" :spaceBetween="30" :slidesPerGroup="3" :loop="true"
                :loopFillGroupWithBlank="true" :pagination="{
                  clickable: true,
                }" :navigation="true" :modules="modules" class="mySwiper">

                <swiper-slide v-for="item in depoimentos" :key="item.id">
                  <div class="team-player">
                    <md-card class="md-card-plain">
                      <div class="md-layout-item md-size-50 mx-auto">
                        <img :src="item.img" alt="Thumbnail Image" class="img-raised rounded-circle img-fluid" />
                      </div>
                      <h4 class="card-title">
                        {{ item.name }}
                        <br />
                        <small class="card-description text-muted">{{ item.city }} / {{ item.state }}</small>
                      </h4>

                      <md-card-content>
                        <p class="card-description">
                          {{ item.message }}
                        </p>
                      </md-card-content>

                    </md-card>
                  </div>
                </swiper-slide>
              </swiper>

              <!--
              <div v-for="item in depoimentos" :key="item.id"
                class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="team-player">
                  <md-card class="md-card-plain">
                    <div class="md-layout-item md-size-50 mx-auto">
                      <img :src="item.img" alt="Thumbnail Image" class="img-raised rounded-circle img-fluid" />
                    </div>
                    <h4 class="card-title">
                      {{ item.name }}
                      <br />
                      <small class="card-description text-muted">{{ item.city }} / {{ item.state }}</small>
                    </h4>

                    <md-card-content>
                      <p class="card-description">
                        {{ item.message }}
                      </p>
                    </md-card-content>

                  </md-card>
                </div>
              </div>
              -->
            </div>
          </div>
        </div>
      </div>

      <div id="faleConosco" class="section section-contacts">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto">
              <h2 class="text-center title">Vamos Conversar</h2>
              <h4 class="text-center description">
                Dúvidas ou sugestões!? Teremos.
              </h4>
              <form class="contact-form">
                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label>Nome</label>
                      <md-input v-model="name" type="text"></md-input>
                    </md-field>
                  </div>                  
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label>Email para resposta</label>
                      <md-input v-model="email" type="email"></md-input>
                    </md-field>
                  </div>
                </div>

                <div class="md-layout">
                  <div class="md-layout-item md-size-100">
                    <md-field>
                      <label>Assunto</label>
                      <md-input v-model="assunto" type="assunto"></md-input>
                    </md-field>
                  </div>
                </div>
                <md-field maxlength="5">
                  <label>Mensagem</label>
                  <md-textarea v-model="message"></md-textarea>
                </md-field>
                <div class="md-layout">
                  <div class="md-layout-item md-size-33 mx-auto text-center">
                    <md-button class="md-success">Enviar</md-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Navigation, Pagination } from 'swiper'

import { SwiperCore, Swiper, SwiperSlide } from 'swiper-vue2'

// Import Swiper styles
import 'swiper/swiper-bundle.css'

SwiperCore.use([Navigation, Pagination])

import '@/assets/css/swiper.css';

/*
  //Este código estava abaixo mas acho que não é necessário
  ,
  setup() {
    return {
      modules: [Pagination, Navigation],
    };
  }
*/
export default {
  bodyClass: "landing-page",
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    header: {
      type: String,
      default: require("@/assets/img/faces/avatar.jpg")
    },
    teamImg1: {
      type: String,
      default: require("@/assets/img/faces/avatar.jpg")
    },
    teamImg2: {
      type: String,
      default: require("@/assets/img/faces/christian.jpg")
    },
    teamImg3: {
      type: String,
      default: require("@/assets/img/faces/kendall.jpg")
    }
  },
  data() {
    return {
      slides: [{
        id: 1,
        title: "Como Pedir Desculpa",
        url: "https://pt.wikihow.com/Pedir-Desculpas",
        img: require("@/assets/img/slides/slide-1.webp")
      }, {
        id: 2,
        title: "Conheça a maneira perfeita de pedir desculpas, segundo a ciência",
        url: "https://revistagalileu.globo.com/Sociedade/noticia/2016/04/conheca-maneira-perfeita-de-pedir-desculpas-segundo-ciencia.html",
        img: require("@/assets/img/slides/slide-2.webp")
      }, {
        id: 3,
        title: "O pedido de desculpas perfeito - de acordo com a ciência",
        url: "https://super.abril.com.br/comportamento/o-pedido-de-desculpas-perfeito-de-acordo-com-a-ciencia/",
        img: require("@/assets/img/slides/slide-3.webp")
      }, {
        id: 4,
        title: "Sabe como é o pedido de desculpas perfeito (ou quase)?",
        url: "https://adriananunan.com.br/psicologia-clinica/sabe-como-e-o-pedido-de-desculpas-perfeito-ou-quase/",
        img: require("@/assets/img/slides/slide-4.webp")
      }],
      depoimentos: [{
        id: 1,
        img: require("@/assets/img/faces/avatar.jpg"),
        name: 'Vania A. S.',
        city: 'Campinas',
        state: 'SP',
        message: 'Meu marido não falava comigo a quase três dias. Esqueci nosso aniversário de casamento e ele ficou furioso. Fiz o Pedido de Desculpa Formal e fui perdoada.'
      }, {
        id: 2,
        img: require("@/assets/img/faces/christian.jpg"),
        name: 'Tania L. T.',
        city: 'Valinhos',
        state: 'SP',
        message: 'Chamei minha amiga de gorda e ela se sentiu ofendida. Nunca pensei que existesse um site como esse e que seria tão útil pra mim.'
      }, {
        id: 3,
        img: require("@/assets/img/faces/kendall.jpg"),
        name: 'Ana M. B.',
        city: 'Americana',
        state: 'SP',
        message: 'Sério que criaram um site como esses? Surreal! Obrigada.'
      }],
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(` + require("@/assets/img/bg_foimal02.jpg") +  `)`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}

.contact-form {
  margin-top: 30px;
}

.md-has-textarea+.md-layout {
  margin-top: 15px;
}

.shadow {
  background-color: rgb(0, 0, 0, 0.3);
  padding: 20px;
  border-radius: 6px;
}

.como-funciona {
  margin-left: auto;
  margin-right: auto;
  display: block;
  max-height: 280px;
}

.como-funciona-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 85%;
}

.swiper-button-prev {
  color: red !important;
}
</style>